//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum MessageBodyFormat {
	Markdown = 0,
	Plain = 1,
	Html = 2
}
